import store, { registerStoreModuleAsync } from 'Store';
import { registerModuleMarket } from 'Store/market';

async function registerStoreModulePortfolio() {
  if (!store.hasModule('portfolio')) {
    const { default: storeModule } = await import(/* webpackChunkName: 'storeModulePortfolio' */ '../store');
    store.registerModule('portfolio', storeModule);
  }
}

async function registerStoreModule(to, from, next) {
  // TODO register Market module
  const promises = [];
  promises.push(registerStoreModulePortfolio());
  promises.push(registerStoreModuleAsync('account'));
  promises.push(registerStoreModuleAsync('beneficiary'));
  await registerStoreModuleAsync('myAdvisors');
  promises.push(registerModuleMarket());
  await Promise.all(promises);
  next();
}
export default [
  // redirects from old path profile/investments to new /portfolio
  {
    path: '/profile/investments/wire/:id',
    redirect: { name: 'wire' },
  },
  {
    path: '/profile/investments/overview',
    redirect: { name: 'profile-investment-tab-overview' },
  },
  {
    path: '/profile/investments/funding',
    redirect: { name: 'profile-investment-tab-funding' },
  },
  {
    path: '/profile/investments/active',
    redirect: { name: 'profile-investment-tab-active' },
  },
  {
    path: '/profile/investments/exited',
    redirect: { name: 'profile-investment-tab-exited' },
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    redirect: { name: 'profile-investment-tab-overview', params: { tab: 'overview' } },
    component: () => import(/* webpackChunkName: 'PagePortfolio' */ '../PagePortfolio'),
    beforeEnter: registerStoreModule,
    meta: {
      requiresAuth: true,
      store: [
        'portfolio/getAccountAccreditationIssueList',
        'portfolio/getPortfolioData',
        'portfolio/setupNotification',
        'account/loadAccountListOnce',
        'investment/getInvestmentList',
        'farm/getList',
        'market/getMarketUserBidList',
        'beneficiary/loadBeneficiaryList',
        'myAdvisors/loadAdvisorsList',
      ],
    },
    children: [
      {
        path: 'overview',
        name: 'profile-investment-tab-overview',
        params: { tab: 'overview' },
      }, {
        path: 'funding',
        name: 'profile-investment-tab-funding',
        params: { tab: 'funding' },
      }, {
        path: 'active',
        name: 'profile-investment-tab-active',
        params: { tab: 'active' },
      }, {
        path: 'exited',
        name: 'profile-investment-tab-exited',
        params: { tab: 'exited' },
      },
    ],
  },
  {
    path: '/portfolio/wire/:id',
    name: 'wire',
    component: () => import(/* webpackChunkName: 'PageWireInstructions' */ 'Components/PageWireInstructions/PageWireInstructions'),
    meta: {
      requiresAuth: true,
      store: ['investment/getInvestmentSingleData'],
    },
  },
];
